<template>
  <div class="page stats">

      <Events></Events>

    <div>
      <div class="stats__card"></div>
    </div>
    <div>
      <div class="stats__card"></div>
    </div>
    <div>
      <div class="stats__card"></div>
    </div>
    <div>
      <div class="stats__card"></div>
    </div>
    <div>
      <div class="stats__card"></div>
    </div>
    <div>
      <div class="stats__card"></div>
    </div>
    <div>
      <div class="stats__card"></div>
    </div>

    <div>
      <div class="stats__card"></div>
    </div>
    <div>
      <div class="stats__card"></div>
    </div>
    <div>
      <div class="stats__card"></div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Events from '@/components/Events.vue'

  export default {
    name: 'Home',
    components: {
      Events
    }
  }
</script>
